// extracted by mini-css-extract-plugin
module.exports = {"panel":"PanelSystem--panel","panelHolder":"PanelSystem--panelHolder","fullScreenButton":"PanelSystem--fullScreenButton"};